import { StyledTabFilters } from "./styled"
import { Grid } from "../Grid";
import { ITabFiltersProps } from "./types";
import { Typography } from "../../basics"
import { FilterButton } from "../FilterButton";

const TabFilters = ({ filters, selectedFilter, onFilterChange }: ITabFiltersProps) => {
    return (
        <StyledTabFilters>
            {filters.map((filter) => (
                <FilterButton
                    key={filter.id}
                    label={filter.label}
                    onClick={() => onFilterChange(filter)}
                    isSelected={selectedFilter.id === filter.id}
                />
            ))}
        </StyledTabFilters>
    )
}

export { TabFilters };